import { listen } from "@/utils/event";
import { event } from "../enums/hmac-validator";
import { emitMixpanelEvent } from "../emit";

listen(event.VisitHmacValidator, (dataOptions: Record<string, unknown>) => {
  emitMixpanelEvent(event.VisitHmacValidator, dataOptions);
});
